import React, { FunctionComponent } from 'react';

import { AlexaText } from '@amzn/monera-app-alexa-shared-libs';
import { CanvasItem, Link, MediaType, Stars } from '@amzn/monera-app-core-components';

import { alexaTheme } from '../../theme';
import { Reviews, StarBox, StyledMedia, Title, TopSkillWidgetContainer, Utterance } from './styles';
import { TopSkillWidgetProps } from './types';

export const WIDGET_WIDTH = 250;

// component for rendering top skill widgets in top skill shovelers
export const TopSkillWidget: FunctionComponent<TopSkillWidgetProps> = (props) => {
  const {
    title,
    imageUrl,
    utterance,
    numStars = '0',
    numReviews = '0',
    productHref,
    reviewHref,
    onTopSkillsWidgetClick,
    // default font-sizes for desktop
    titleFontSize = alexaTheme.typography?.desktopBody?.fontSize,
    reviewsFontSize = alexaTheme.typography?.desktopSM?.fontSize,
    utteranceFontSize = alexaTheme.typography?.desktopBody?.fontSize
  } = props;

  const utteranceLineHeight = alexaTheme.typography?.desktopBody?.lineHeight;
  const parsedNumReviews = parseInt(numReviews);
  const formattedNumReviews = isNaN(parsedNumReviews) ? '0' : parseInt(numReviews).toLocaleString();

  return (
    <TopSkillWidgetContainer
      data-cy={'top-skill-widget-container'}
      borderRadius="5px"
      direction="column"
      width={WIDGET_WIDTH + 'px'}
      color="#f4f6f6"
      padding="5px"
      border="1px solid #eaeded"
      onClick={onTopSkillsWidgetClick}
    >
      <Utterance href={productHref}>
        <StyledMedia
          data-cy={'top-skill-widget-skill-logo'}
          mediaSrcUrl={imageUrl}
          mediaSrcType={MediaType.Image}
          lazyLoad={true}
          width="82px"
          height="82px"
          alt={title}
        />
        <CanvasItem textAlign="center">
          <AlexaText
            italic
            data-cy={'top-skill-widget-utterance-text'}
            lineHeight={utteranceLineHeight}
            fontSize={utteranceFontSize}
            color="#0F1111"
          >
            {utterance}
          </AlexaText>
        </CanvasItem>
      </Utterance>
      <Title>
        <Link data-cy={'top-skill-widget-title-text'} fontSize={titleFontSize} href={productHref}>
          {title}
        </Link>
      </Title>
      <Reviews href={reviewHref}>
        <StarBox margin="0 2px 0 0">
          <Stars numStars={parseFloat(numStars)} />
        </StarBox>
        <AlexaText color="#007185" data-cy={'top-skill-widget-total-reviews-text'} fontSize={reviewsFontSize}>
          &nbsp;{formattedNumReviews}
        </AlexaText>
      </Reviews>
    </TopSkillWidgetContainer>
  );
};
export * from './types';
